import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

import { enTranslationResources } from './translation/en';
import { frTranslationResources } from './translation/fr';

i18next.use(initReactI18next).init({
  resources: {
    en: enTranslationResources,
    fr: frTranslationResources,
  },
  lng: 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
  },
});
export const i18n = i18next;
